import api from "../utils/api";
import { gQuery } from "../Graphql/gQuery";
import { queryPdpDeliveryMethods } from "../Graphql/queryPdpDeliveryMethods";
import { S_LANG, webStorage } from "../utils/webStorage";
export const getStockLcc = async () => {
  const { obj } = await api.vehicle.stock.lcc();
  return obj[0];
};
export const checkPdpStock = async ({ lccId, towbarState, modelConfigCode, stocktype }) => {
  try {
    const { obj } = await api.vehicle.stock.check(null, {
      vehicles: [
        {
          warehouseOrgId: lccId,
          towbarState,
          modelConfigCode,
          reserved: ""
        }
      ],
      stocktype: stocktype
    });
    return obj;
  } catch (err) {
    return err.obj;
  }
};
export const getPdpDeliveryMethods = async () => {
  const lang = webStorage.get(S_LANG);
  const {
    data: { obj }
  } = await gQuery({
    query: queryPdpDeliveryMethods,
    variables: {
      language: lang
    }
  });
  if (!obj) {
    return [];
  }
  const { list } = obj;
  return list.map(l => ({
    key: l.key.value,
    value: l.key.value,
    label: l.label.value,
    body: l.body.value,
    closeText: l.closeText.value
  }));
};
